import type { PaymentSource } from "types/billing/PaymentSource";

// Chargebee mutation endpoints still return the legacy nested response.
// Reads and Stripe mutations already return the normalized billing contract.
export type LegacyPaymentSource = {
  id: string;
  type: "card" | "paypal_express_checkout";
  is_primary?: boolean;
  card?: {
    brand: string;
    last4: string;
    expiry_month: number;
    expiry_year: number;
    first_name?: string;
  };
  paypal?: { email?: string };
};

export function normalizePaymentSources(
  sources: Array<PaymentSource | LegacyPaymentSource> | null
): PaymentSource[] | null {
  return sources?.map(source => {
    if ("isPrimary" in source) return source;
    if (source.type === "paypal_express_checkout") {
      return {
        ...source,
        type: "paypal" as const,
        isPrimary: source.is_primary === true,
        paypalEmail: source.paypal?.email
      };
    }
    if (!source.card) throw new Error("Card payment source is missing card details");
    return {
      ...source,
      type: "card" as const,
      isPrimary: source.is_primary === true,
      brand: source.card.brand,
      last4: source.card.last4,
      expiry: { month: source.card.expiry_month, year: source.card.expiry_year },
      nameOnCard: source.card.first_name
    };
  }) ?? null;
}
